import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			unitgroup: undefined,
			facilityid: undefined,
			selectedImageIndex: undefined,
			units: []
		};
	},
	props: {
		//facilityid: [Number, String]
	},
	beforeMount: function () {
		let el = document.querySelector("[data-facility-id]");
		if (el) {
			this.facilityid = parseInt(el.getAttribute('data-facility-id'), 10);
		} else {
			//console.log('element beds is not found..................');
		}
		if (this.facilityid) {

			switch (this.facilityid) {
			case 162495:
				this.unitgroup = undefined; //Haffhäuser
				break;
			case 124310:
				this.unitgroup = 60726; //Der Landhof
				break;
			case 124311:
				this.unitgroup = 60729; //Das Landhaus am Haff
				break;
			case 124308:
				this.unitgroup = 60728; //Die Remise
				break;
			case 124309:
				this.unitgroup = 60727; //Der Westflügel
				break;
			default:
				console.log("Keine Unitgroup gefunden");
			}

		}
		//console.log('FacilityID:::', this.facilityid);
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}

		if (this.unitgroup) {

			var req = {
				fields: this.resultFields,
				filter: {
					unitgroupid: this.unitgroup
				},
				max: 40,
				sorting: 'code',
			};

			this.doSearchNow(req);
		}

	},


	updated: function () {
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
	},
	methods: {
		getSearchLink: function () {
			if (this.unitgroup) {
				return './s#?unitgroupid=' + this.unitgroup;
			}
		},
		doSearchNow: function (req) {
			doReq('searchUnits', req)
				.then((res) => {
					this.units = res.units;
				});

		},
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				//probably phone?
				return '_self';
			} else {
				return 'unit_' + id;
			}
		},
	},
	filters: {
		formatfeedback: function (value) {
			if (!value) return '';
			if (Number.isInteger(value)) return value.toFixed();
			return (value.toFixed(1).replace('.', ','));
		}
	}

};